export default __webpack_public_path__ + "static/media/II-2022.26b799a3.pdf";